import { fetchAuthSession } from "aws-amplify/auth"

import { MULTI_FETCH_PROTECTED_ACCESS } from "../../constants/roles"
/**
 * Assesses if a given user should be directed via the protected
 * or public API routes. Only used in API hooks which can direct
 * users to either the protected or public API clients (for example)
 * for the LCT/TTR routes.
 * @param {boolean} isSignedIn - auth status of user
 * @param {string[]} groups - cognito groups / roles
 * @returns {boolean} - `True` if users can access protected routes
 */
export const canAccessProtectedRoutes = (
    isSignedIn: boolean,
    groups: string[]
): boolean =>
    isSignedIn &&
    groups.some((userGroup) => MULTI_FETCH_PROTECTED_ACCESS.includes(userGroup))

/**
 * Forces a token refresh for the current authenticated user.
 * @returns {Promise<void>} - resolves when the token has been refreshed
 * @throws {Error} - if the token refresh fails
 */
export const forceTokenRefresh = async (): Promise<void> => {
    await fetchAuthSession({ forceRefresh: true })
}
